import React, { Component } from 'react';
import { Row, Col, Input, Container, Card, CardBody, Button } from 'reactstrap';
import './Payment.css';
import bannerWirewayWebp from './banner-wireway.webp';
import bannerWirewayPng from './banner-wireway.png';

export class Payment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            internetTarifs: [],
            cameraTarifs: [],
            internetTarif: {},
            cameraTarif: {},
            months: 1,
            cameraCount: 1,
            account: '',
            validate: false,
            loading: true,
            submitting: false
        };

        this.handleAccChange = this.handleAccChange.bind(this);
        this.handleInternetTarifChange = this.handleInternetTarifChange.bind(this);
        this.handleCameraTarifChange = this.handleCameraTarifChange.bind(this);
        this.handleInternetMonthsChange = this.handleInternetMonthsChange.bind(this);
        this.handleCameraCountChange = this.handleCameraCountChange.bind(this);
        this.handleAccountWheel = this.handleAccountWheel.bind(this);
    }

    handleAccChange(event) {
        if (event.target.value <= 99999) {
            this.setState({ account: event.target.value });
            this.getAccount(event.target.value);
        } else {
            this.setState({ account: '' });
            alert("Неверный лицевой счет(не может быть больше 99999)!!!");
        }
    }

    // Блокировка скролла для поля лицевого счета
    handleAccountWheel(event) {
        event.target.blur();
    }

    handleInternetTarifChange(event) {
        this.getTarif(event.target.value);
    }

    handleCameraTarifChange(event) {
        this.getCameraTarif(event.target.value);
    }

    handleInternetMonthsChange(event) {
        this.setState({ months: parseInt(event.target.value) || 1 });
    }

    handleCameraCountChange(event) {
        this.setState({ cameraCount: parseInt(event.target.value) || 1 });
    }

    componentDidMount() {
        this.getTarifs();
        this.getCameraTarifs();
    }

    render() {
        const internetTotal = (this.state.internetTarif.price || 0) * this.state.months;
        const cameraTotal = (this.state.cameraTarif.price || 0) * this.state.cameraCount * this.state.months;
        const grandTotal = internetTotal + cameraTotal;

        // Генерация массивов для выпадающих списков
        const monthsOptions = Array.from({ length: 12 }, (_, i) => i + 1);
        const cameraCountOptions = Array.from({ length: 5 }, (_, i) => i + 1);

        return (
            <Container className="payment-container">
                <Row className="mb-1">
                    <Col>
                        <h1 className="payment-title">Пополнить счет</h1>
                    </Col>
                </Row>

                <Card className="payment-card">
                    <CardBody>
                        <Row className="mb-1">
                            <Col md="12" className="mb-3">
                                <div className="form-group">
                                    <label htmlFor="input-account" className="form-label">Лицевой счет</label>
                                    <Input
                                        type="number"
                                        name="account"
                                        id="input-account"
                                        className="form-control-lg withoutArrows elink-input"
                                        valid={this.state.validate}
                                        invalid={!this.state.validate && this.state.account !== ''}
                                        max="99999"
                                        placeholder="Введите лицевой счет"
                                        value={this.state.account}
                                        onChange={this.handleAccChange}
                                        onWheel={this.handleAccountWheel}
                                    />
                                    <div className="form-text">
                                        Номер лицевого счета указан в памятке пользователя.
                                        Зачисление платежа происходит в течение 10 минут.
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        {this.state.validate && (
                            <a
                                href="https://wireway.me/signup"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="wireway-banner"
                            >
                                <picture>
                                    <source srcSet={bannerWirewayWebp} type="image/webp" />
                                    <img
                                        src={bannerWirewayPng}
                                        alt="Wireway — интернет без ограничений. Регистрируйся!"
                                        loading="lazy"
                                    />
                                </picture>
                            </a>
                        )}

                        <Row className="mb-1">
                            <Col md="6" className="mb-3 mb-md-0">
                                <div className="form-group">
                                    <label htmlFor="selectInternetTarif" className="form-label">Тариф интернета</label>
                                    <Input
                                        type="select"
                                        name="selectInternet"
                                        id="selectInternetTarif"
                                        className="form-control-lg elink-input"
                                        onChange={this.handleInternetTarifChange}
                                        value={this.state.internetTarif._id || 0}
                                    >
                                        <option value='0'>Выберите тариф интернета...</option>
                                        {this.state.internetTarifs.map(item =>
                                            <option value={item._id} key={`internet-${item._id.toString()}`}>{item.name}</option>
                                        )}
                                    </Input>
                                </div>
                            </Col>

                            <Col md="6">
                                <div className="form-group">
                                    <label htmlFor="selectCameraTarif" className="form-label">Тариф видеонаблюдения</label>
                                    <Input
                                        type="select"
                                        name="selectCamera"
                                        id="selectCameraTarif"
                                        className="form-control-lg elink-input"
                                        onChange={this.handleCameraTarifChange}
                                        value={this.state.cameraTarif.id || 0}
                                    >
                                        <option value='0'>Выберите тариф видеонаблюдения...</option>
                                        {this.state.cameraTarifs.map(item =>
                                            <option value={item.id} key={`camera-${item.id.toString()}`}>{item.name}</option>
                                        )}
                                    </Input>
                                </div>
                            </Col>
                        </Row>

                        <Row className="mb-1">
                            <Col md="12">
                                <Card className="payment-info-card">
                                    <CardBody>
                                        <h4 className="payment-title">Информация по платежу</h4>

                                        {this.state.internetTarif._id && (
                                            <div className="payment-section mb-1">
                                                <div className="section-header">
                                                    <h5 className="section-title">Интернет</h5>
                                                </div>
                                                <Row className="align-items-center py-2">
                                                    <Col md="4">
                                                        <div className="service-info">
                                                            <span className="service-name">{this.state.internetTarif.name}</span>
                                                            <div className="service-price">
                                                                {this.state.internetTarif.price} руб./мес
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col md="3">
                                                        <div className="quantity-control">
                                                            <label className="quantity-label">Месяцев:</label>
                                                            <Input
                                                                type="select"
                                                                value={this.state.months}
                                                                onChange={this.handleInternetMonthsChange}
                                                                className="quantity-input"
                                                            >
                                                                {monthsOptions.map(month => (
                                                                    <option key={month} value={month}>
                                                                        {month}
                                                                    </option>
                                                                ))}
                                                            </Input>
                                                        </div>
                                                    </Col>
                                                    <Col md="5" className="text-right">
                                                        <div className="total-line">
                                                            <span className="total-label">Итого:</span>
                                                            <span className="total-amount">{internetTotal} руб.</span>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        )}

                                        {this.state.cameraTarif.id && (
                                            <div className="payment-section">
                                                <div className="section-header">
                                                    <h5 className="section-title">Видеонаблюдение</h5>
                                                </div>
                                                <Row className="align-items-center py-2">
                                                    <Col md="4">
                                                        <div className="service-info">
                                                            <span className="service-name">{this.state.cameraTarif.name}</span>
                                                            <div className="service-price">
                                                                {this.state.cameraTarif.price} руб./мес/камера
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col md="3">
                                                        <div className="quantity-control">
                                                            <label className="quantity-label">Камеры:</label>
                                                            <Input
                                                                type="select"
                                                                value={this.state.cameraCount}
                                                                onChange={this.handleCameraCountChange}
                                                                className="quantity-input"
                                                            >
                                                                {cameraCountOptions.map(count => (
                                                                    <option key={count} value={count}>
                                                                        {count}
                                                                    </option>
                                                                ))}
                                                            </Input>
                                                        </div>
                                                    </Col>
                                                    <Col md="2">
                                                        <div className="quantity-control">
                                                            <label className="quantity-label">Месяцев:</label>
                                                            <Input
                                                                type="select"
                                                                disabled={this.state.internetTarif._id}
                                                                value={this.state.months}
                                                                onChange={this.handleInternetMonthsChange}
                                                                className="quantity-input"
                                                            >
                                                                {monthsOptions.map(month => (
                                                                    <option key={month} value={month}>
                                                                        {month}
                                                                    </option>
                                                                ))}
                                                            </Input>
                                                        </div>
                                                    </Col>
                                                    <Col md="3" className="text-right">
                                                        <div className="total-line">
                                                            <span className="total-label">Итого:</span>
                                                            <span className="total-amount">{cameraTotal} руб.</span>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        )}

                                        {!this.state.internetTarif._id && !this.state.cameraTarif.id && (
                                            <div className="payment-placeholder">
                                                Выберите тарифы для расчета стоимости
                                            </div>
                                        )}
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

                        <Row className="align-items-center">
                            <Col md="6" className="mb-3 mb-md-0">
                                <div className="grand-total">
                                    <span className="total-label">К оплате:</span>
                                    <span className="total-amount">{grandTotal} руб.</span>
                                </div>
                            </Col>
                            <Col md="6" className="text-md-right">
                                <Button
                                    disabled={this.state.submitting || !this.state.validate || (!this.state.internetTarif._id && !this.state.cameraTarif.id)}
                                    onClick={this.handleSubmit.bind(this)}
                                    className="elink-button"
                                    size="lg"
                                >
                                    {this.state.submitting ? 'Обработка...' : 'Оплатить'}
                                </Button>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Container>
        );
    }

    async handleSubmit() {
        if (this.state.submitting) return;
        if ((this.state.internetTarif._id || this.state.cameraTarif.id)) {
            this.setState({ submitting: true });
            try {
                const parts = [
                    this.state.internetTarif?.name,
                    this.state.cameraTarif?.name
                ].filter(Boolean);
                const tarif = parts.join('+');

                const data = {
                    account: this.state.account,
                    amount: (this.state.internetTarif.price || 0) * this.state.months +
                        (this.state.cameraTarif.price || 0) * this.state.cameraCount * this.state.months,
                    tarif: tarif
                }

                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(data)
                };
                const response = await fetch('api/Payment/PostPayment', requestOptions);
                const res = await response.json();
                if (res != null) {
                    if (res.confirmation != null) {
                        window.location.href = res.confirmation.confirmation_url;
                        return;
                    }
                }
            } finally {
                this.setState({ submitting: false });
            }
        } else {
            alert("Выберите хотя бы один тариф!");
        }
    }

    async getTarifs() {
        const response = await fetch('api/Tarifs');
        const data = await response.json();
        this.setState({ internetTarifs: data, loading: false });
    }

    async getTarif(id) {
        if (id !== 0) {
            const response = await fetch('api/Tarifs/' + id);
            const data = await response.json();
            this.setState({ internetTarif: data, loading: false });
        } else {
            this.setState({ internetTarif: {}, loading: false })
        }
    }
    async getCameraTarifs() {
        const response = await fetch('api/CameraTarifs');
        const data = await response.json();
        this.setState({ cameraTarifs: data, loading: false });
    }

    async getCameraTarif(id) {
        if (id !== 0) {
            const response = await fetch('api/CameraTarifs/' + id);
            const data = await response.json();
            this.setState({ cameraTarif: data, loading: false });
        } else {
            this.setState({ cameraTarif: {}, loading: false })
        }
    }
    async getAccount(id) {
        // Эндпоинт отвечает только 200/404 — телефон и данные абонента на клиент не передаются.
        const response = await fetch('api/Accounts/' + id);
        if (response.ok) {
            this.setState({ validate: true, loading: false })
        } else {
            this.setState({ validate: false, loading: false })
        }
    }
}